let baseUrl;
switch (process.env.VUE_APP_TITLE) {
  case 'test':
    // 本地
    // baseUrl = "https://lcw.scangoo.cn/";
    // 线上https://lcw.scangoo.cn
    baseUrl = 'https://scslkt.cn/';
    break;
  case 'production':
    baseUrl = 'https://scslkt.cn/';
    break;
  default:
    baseUrl = 'https://scslkt.cn/';
    break;
}
export default baseUrl;
